module.exports = "<div ncy-breadcrumb></div> <div class=site-title> <h1><translate>You searched for</translate> '{{::vm.searchValue}}'</h1> </div> <product-overview context=search-view parent-state=vm.parentState model=vm.productOverviewModel></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/search/search.html
// module id = 659
// module chunks = 0